import React, { ReactNode } from 'react';

import { ColorSearchIcon } from '@/components';

export const Empty = ({ title, description }: { title?: ReactNode; description?: ReactNode }) => {
  return (
    <div className="flex flex-col items-center justify-center py-[40px] w-full">
      <ColorSearchIcon />
      <div className="text-gray-900 font-medium text-md mt-[16px]">
        {title || <span>There&apos;s nothing here 😴</span>}
      </div>
      <div className="text-gray-500 text-sm mt-[4px] text-center">{description}</div>
    </div>
  );
};
